import { twMerge } from "tailwind-merge";
import { Link } from "react-router-dom";
import { Summary } from "../../../../components/ui/Summary";

export function MetricCard({ icon, value, label, link, className, loading = false, }) {
  const Container = link ? Link : "div";
  return (
    <Container className="flex-1 flex" to={link}>
      <Summary.Box className={twMerge("!min-w-[210px]", className)}>
        <Summary.Icon icon={icon} />
        <Summary.TextContent>
          <Summary.Title>
            {loading && <span className="block h-5 w-20 animate-pulse rounded bg-gray-200" />}
            {!loading && value}
          </Summary.Title>
          <Summary.Text>
            {label}
          </Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
    </Container>
  );
}
